import { create } from 'zustand'
import { jobsApi, matchesApi, candidatesApi } from '../lib/api'

const useJobStore = create((set, get) => ({
  // --- State ---
  jobs: [],
  activeJob: null,
  candidates: [],
  loadingJobs: false,
  loadingCandidates: false,
  error: null,

  // --- Jobs ---
  fetchJobs: async (status = 'active') => {
    set({ loadingJobs: true, error: null })
    try {
      const data = await jobsApi.list(status)
      set({ jobs: data.jobs || [], loadingJobs: false })
      return data
    } catch (error) {
      set({ error: error.message, loadingJobs: false })
      return { jobs: [] }
    }
  },

  createJob: async (jobData) => {
    try {
      const data = await jobsApi.create(jobData)
      await get().fetchJobs()
      return { success: true, job: data.job }
    } catch (error) {
      return { success: false, error: error.message }
    }
  },

  updateJob: async (jobId, updates) => {
    try {
      await jobsApi.update(jobId, updates)
      await get().fetchJobs()
      return { success: true }
    } catch (error) {
      return { success: false, error: error.message }
    }
  },

  deleteJob: async (jobId) => {
    try {
      await jobsApi.delete(jobId)
      set((state) => ({
        jobs: state.jobs.filter((j) => j.jobId !== jobId),
      }))
      return { success: true }
    } catch (error) {
      return { success: false, error: error.message }
    }
  },

  archiveJob: async (jobId) => {
    try {
      await jobsApi.update(jobId, { status: 'archived' })
      await get().fetchJobs()
      return { success: true }
    } catch (error) {
      return { success: false, error: error.message }
    }
  },

  setActiveJob: (job) => set({ activeJob: job, candidates: [] }),

  // --- Candidates ---
  fetchCandidates: async (jobId, status) => {
    set({ loadingCandidates: true, error: null })
    try {
      const data = await matchesApi.getRanked(jobId, status)
      set({
        candidates: data.candidates || [],
        loadingCandidates: false,
      })
      return data
    } catch (error) {
      set({ error: error.message, loadingCandidates: false })
      return { candidates: [] }
    }
  },

  updateCandidateStatus: async (jobId, candidateId, status) => {
    try {
      await candidatesApi.updateStatus(jobId, candidateId, status)
      set((state) => ({
        candidates: state.candidates.map((c) =>
          c.candidateId === candidateId ? { ...c, status } : c
        ),
      }))
      return { success: true }
    } catch (error) {
      return { success: false, error: error.message }
    }
  },

  // --- Clear state ---
  clearCandidates: () => set({ candidates: [], activeJob: null }),
  clearError: () => set({ error: null }),
}))

export default useJobStore
